import { catchError, Observable, of } from 'rxjs';
import { Injector } from '@angular/core';
import { UiToastMessageService, UiTranslateLoaderService } from 'ui-shared';

export function catchHttpError<T>(injector: Injector, value = null){
    const translateService = injector.get(UiTranslateLoaderService);
    const toastMessageService = injector.get(UiToastMessageService);
    return function(source: Observable<T>): Observable<T> {
        return source.pipe(catchError(e=>{
            const errorCode = e.error?.errorDetail?.errorCode;
            if (errorCode) toastMessageService.showError(translateService.instant(errorCode));
            return of(value);
        }));
    }
}
